import React from 'react';
import { Card, Typography } from '../ecosystem';

export const DashboardTile = ({
    className = '',
    children,
    circleButtonHover,
    heading,
    href,
    onClick,
    target,
    title,
    to,
    noBorder = false,
    disabled
}) => {

    const dashboardTileClasses = [
        `${'dashboard-tile'}`,
        `${circleButtonHover ? 'circle-button-hover' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <Card
            className={dashboardTileClasses}
            onClick={onClick}
            href={href}
            target={target}
            to={to}
            disabled={disabled}
            borderStyle={noBorder ? 'none' : 'flat'}
        >
            {(title || heading) &&
                <div className="row dashboard-tile__heading">
                    {title
                        ? <div className="col-12">
                            <Typography tag="div" type="heading-02" bold>{title}</Typography>
                        </div>
                        : heading
                    }
                </div>
            }
            <div className="row dashboard-card__body">
                {children}
            </div>
        </Card>
    )
}